// Lib
import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../../styles/palette';

export const useStyles = makeStyles()((theme, { fontSize } = {}) => ({
  errorIcon: { minWidth: 20, marginTop: 3, cursor: 'initial' },
  errorContainer: {
    alignItems: 'baseline',
    display: 'flex',
  },
  error: {
    color: colors.gilead.primary1,
    fontSize,
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
}));
